import React, { useContext } from 'react';

import RightScenes from '../components/Menu/BarDashboard/RightScenes/RightScenes';
import { Loan } from '../../../gql/graphql';
import { useLoans } from './hooks/useLoans';
import LoansHeader from './components/LoansHeader/LoansHeader';
import LoanCard from './components/LoanCard/LoanCard';
import { ScrollSentinel } from '../../../components/Atoms/ScrollSentinel/ScrollSentinel';

interface LoansProps {
  LoansViewContext: any;
}

const Loans = ({ LoansViewContext }: LoansProps) => {
  const { visible, setHandlerVisible, lockedDeadLayout, setLockedDeadLayout }: any = useContext(LoansViewContext);

  const {
    loanStateFilter,
    setLoanStateFilter,
    searchTerm,
    handleSearch,
    tabTotals,
    filter,
    setFilter,
    tabFilteredLoans,
    fetching,
    hasMore,
    sentinelRef,
  } = useLoans({ lockedDeadLayout, setLockedDeadLayout, setHandlerVisible });

  return (
    <RightScenes
      visible={visible}
      handlerSetVisibile={setHandlerVisible}
    >
      <div className='view-loans'>
        <LoansHeader
          loanStateFilter={loanStateFilter}
          onLoanStateChange={setLoanStateFilter}
          searchTerm={searchTerm}
          onSearch={handleSearch}
          tabTotals={tabTotals}
          filter={filter}
          onFilterChange={setFilter}
        />

        <div className='view-loans-content'>
          {tabFilteredLoans.map((loan: Loan) => (
            <LoanCard key={loan._id} loan={loan} />
          ))}

          {hasMore && !fetching && <ScrollSentinel ref={sentinelRef} />}
        </div>
      </div>
    </RightScenes>
  );
};

export default Loans;
